<form [formGroup]="filtersGroup" class="mat-elevation-z3">
  <div class="searchBox" >
    @if (systemTypes.length > 0) {
      <mat-form-field>
        <mat-label>
          {{ 'WINDOW|Typy systemów:' | translate }}
        </mat-label>
        <mat-select formControlName="type">
          <mat-option value=''>{{'WINDOW|Dowolne' | translate}}</mat-option>
          @for (type of systemTypes; track type) {
            <mat-option [value]="type.id">{{ type.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (systemGroups.length > 0) {
      <mat-form-field>
        <mat-label>
          {{ 'WINDOW|Grupy systemów:' | translate }}
        </mat-label>
        <mat-select formControlName="groupId">
          <mat-option value=''>{{'WINDOW|Dowolne' | translate}}</mat-option>
          @for (group of systemGroups; track group) {
            <mat-option [value]="group.id">{{ group.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
  <div class="searchBox" formArrayName="tags">
    <h4>{{ 'WINDOW|Tagi:' | translate }}</h4>
    @for (tag of systemTags; track tag; let i = $index) {
      <mat-checkbox  [formControlName]="i">
        {{ tag.name }}
      </mat-checkbox>
    }
  </div>
  <button mat-raised-button color="primary" (click)="save()"
  >{{ 'INTERFACE|OK' | translate }}</button>
</form>

